import { render, staticRenderFns } from "./HoldingBondsTable.vue?vue&type=template&id=5a123d2a&"
import script from "./HoldingBondsTable.vue?vue&type=script&lang=js&"
export * from "./HoldingBondsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports